import {AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { TramitesPorEstadoComponent } from './tramites-por-estado/tramites-por-estado.component';
import { TareasPendientesComponent } from './tareas-pendientes/tareas-pendientes.component';
import { ActivatedRoute } from '@angular/router';
import {ButtonDirective} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SvgLoaderComponent} from "lib-base";
import {firstValueFrom, forkJoin} from "rxjs";
import {MessageService} from "primeng/api";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-estado-tramites',
  standalone: true,
  imports: [TabViewModule, TramitesPorEstadoComponent, TranslateModule, TareasPendientesComponent, ButtonDirective,
    InputTextModule, ReactiveFormsModule, FormsModule, SvgLoaderComponent, NgIf],
  templateUrl: './estado-tramites.component.html',
  styleUrl: './estado-tramites.component.scss'
})
export class EstadoTramitesComponent implements OnInit, AfterViewInit {

  translations: any = {};
  radicado:string | null = null;
  numeroRadicado:string | null = null;
  activeTabIndex: number = 0;
  private _solicitudId ?: number;
  @ViewChildren(TramitesPorEstadoComponent) tramitesPorEstadoComponents !: QueryList<TramitesPorEstadoComponent>;
  @ViewChild(TareasPendientesComponent) tareasPendientesComponents !: TareasPendientesComponent;

  constructor(private readonly _route: ActivatedRoute, private readonly cdr: ChangeDetectorRef,
              private _ms: MessageService, private _t: TranslateService){

  }

  ngAfterViewInit(): void {
    this._route.queryParams.subscribe(params => {
      let index = Number(params['tabIndex'] ?? 0);
      this._solicitudId = params['solicitudId'] ? Number(params['solicitudId']) : undefined;
      this.activeIndexChange(index);
      this.cdr.detectChanges();
    });
  }

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if(index === 1) {
      this.tareasPendientesComponents.getTramites(this._solicitudId);
      return;
    }
    const component = this.tramitesPorEstadoComponents.toArray()[index];
    if (component) {
      component.getTramites();
    }
  }

  ngOnInit(): void {
    this.getTranslate();
  }


  private async getTranslate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      titulo: this._t.get('components.app-estado-tramites.titulo'),
      tuTramite: this._t.get('components.app-estado-tramite-pub.tu-tramite'),
      header: this._t.get('common.tramites'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      warnDetails: this._t.get('form.msg.campo-requerido'),

    }));
  }

  search(ignore:boolean = false) {
     if(!this.numeroRadicado?.trim() && !ignore) {
       this._ms.add({
          severity: 'warn',
          summary: this.translations.warnSummary,
          detail: this.translations.warnDetails,
          life: 3000
       })
      return;
    }
     if (ignore)this.numeroRadicado = null;
    this.radicado = this.numeroRadicado;
  }
}
